import { QueryKeys } from 'queries';
import { useQuery } from 'react-query';

import apiService from 'services/api/ApiService';

export const useGetGameDetails = (id: string) => {
  const { data: game, isLoading } = useQuery(
    QueryKeys.gamedetail.byId(id),
    () => apiService.getGameDetails(id),
    { enabled: !!id },
  );

  return {
    isLoading,
    game,
  };
};
